import { gql } from '@apollo/client'
import { useQuery } from '@apollo/client/react'
import { CONFIGURATION_QUERY } from '../../graphql'
import { CONFIG_KEYS } from '../../constants'

export const CONFIGURATION = gql(CONFIGURATION_QUERY)

export default function LoginImage() {
  console.log('LoginImage rendered')

  const { loading, error, data } = useQuery(CONFIGURATION, { variables: { key: CONFIG_KEYS.loginImageSource.key } })

  if (error) return `Error! ${error.message}`
  if (loading || !data) return 'Loading...'
  let imageUrl = CONFIG_KEYS.loginImageSource.defaultValue
  if (data.configuration && data.configuration.value) {
    imageUrl = data.configuration.value
  }
  return <img className="login-image" src={imageUrl} alt="CaseEnsemble 2.0" data-cy="login-image" />
}
